var map = {
	"./Grisehale.jpg": 5039,
	"./Grisens-udvikling-2.jpg": 8487,
	"./Grisens-udvikling.jpg": 30,
	"./Griseracer.png": 7121,
	"./Grisestalde.png": 3576,
	"./Jaka bov.jpg": 765,
	"./LandbrugFodevare.svg": 9056,
	"./Lasse 4.png": 5109,
	"./Lille-Gris.jpg": 2451,
	"./Skoleophold_tarmrenser.png": 5007,
	"./Slagtere på JAKA-fabrikken.jpg": 2715,
	"./Tarmset inkl mave.jpeg": 6431,
	"./Tarmset-inkl-mave.jpeg": 359,
	"./Tema_Hovedforløb.png": 5934,
	"./Uddannelses_Forløb.png": 4074,
	"./Udskæringsplanche.png": 4492,
	"./bagskank.jpg": 1461,
	"./bg-explore-consumer.svg": 4889,
	"./bg-explore-education.svg": 3780,
	"./bg-explore-educationold.svg": 5278,
	"./bg-explore-farm.svg": 3189,
	"./bg-explore.svg": 9943,
	"./bg-farmer-life.svg": 8820,
	"./bg-landing.svg": 3637,
	"./bg-pig-cuts.svg": 4,
	"./bov_steg.jpg": 2006,
	"./bryst_hel_uden_ben_overside.jpg": 2664,
	"./butchery-topic-hover.svg": 1556,
	"./challenges/file-for-git": 9937,
	"./china-flag.png": 7983,
	"./fillet-royal.jpg": 2492,
	"./flæskesteg-hel.jpg": 6369,
	"./forskank.jpg": 6865,
	"./hakket_8_procent_fedt.jpg": 6359,
	"./hjerte-gris.jpg": 8865,
	"./icon-cuttingInstructions.svg": 8124,
	"./icon-image.svg": 1800,
	"./icon-loading.svg": 7213,
	"./icon-medal-bronze.svg": 8929,
	"./icon-medal-gold.svg": 6559,
	"./icon-medal-silver.svg": 5416,
	"./icon-recipe.svg": 9409,
	"./icon-sustainability.svg": 6174,
	"./icon-tail-filled.svg": 7648,
	"./icon-tail.svg": 9321,
	"./icon-video.svg": 7971,
	"./icon-x.svg": 45,
	"./img-archetypes-selected.svg": 5932,
	"./img-archetypes.svg": 9839,
	"./img-butcher.svg": 865,
	"./img-butchery.svg": 8975,
	"./img-consumer.svg": 7310,
	"./img-detail-selected.svg": 3726,
	"./img-detail.svg": 5810,
	"./img-engine-room.svg": 2777,
	"./img-farm.svg": 8766,
	"./img-farmer.svg": 5027,
	"./img-food-service-selected.svg": 3233,
	"./img-food-service.svg": 5797,
	"./img-happens-at-butchery.svg": 2927,
	"./img-international-selected.svg": 7482,
	"./img-international.svg": 5650,
	"./japan-flag.png": 5795,
	"./kaebe.png": 154,
	"./korea-flag.png": 4306,
	"./lever-gris.jpg": 6371,
	"./logo-cgl-dark.svg": 6123,
	"./mignon.jpg": 2542,
	"./minutstrimler.jpg": 6791,
	"./nakkefilet.jpg": 9987,
	"./nakkesteg.jpg": 5949,
	"./pig-bronze-medal.svg": 5352,
	"./pig-gold-medal.svg": 2155,
	"./pig-silver-medal.svg": 6950,
	"./pig/bagskank-zoomed.svg": 3043,
	"./pig/bagskank.svg": 9290,
	"./pig/bov-zoomed.svg": 5108,
	"./pig/bov.svg": 296,
	"./pig/bryst-zoomed.svg": 7058,
	"./pig/bryst.svg": 9088,
	"./pig/fillet.svg": 5975,
	"./pig/head-zoomed.svg": 4307,
	"./pig/head.svg": 4102,
	"./pig/indmad-zoomed.svg": 4040,
	"./pig/indmad.svg": 8197,
	"./pig/loin-zoomed.svg": 3882,
	"./pig/loin.svg": 4941,
	"./pig/neck-zoomed.svg": 6117,
	"./pig/neck.svg": 9758,
	"./pig/pig-old.svg": 5,
	"./pig/pig.svg": 2995,
	"./pig/ribs.svg": 2746,
	"./pig/roast-pork.svg": 3663,
	"./pig/skank-zoomed.svg": 2209,
	"./pig/skank.svg": 4200,
	"./pig/skinke-zoomed.svg": 7966,
	"./pig/skinke.svg": 7429,
	"./pig/tail-zoomed.svg": 5076,
	"./pig/tail.svg": 9851,
	"./pig/tenderloin-zoomed.svg": 6266,
	"./pig/tenderloin.svg": 6571,
	"./pointer.svg": 9866,
	"./ribbenssteg_af_stegestykke_med_ben.jpg": 5016,
	"./rullesteg_af_slag.jpg": 6341,
	"./saute-skiver-gris.jpg": 9275,
	"./skank-gris.jpg": 4786,
	"./slag.jpg": 2554,
	"./stegeflæsk.jpg": 1063,
	"./svinebryst.jpg": 4640,
	"./svinekam-uden-svær.jpg": 6666,
	"./tema-hovedforløb.png": 2054,
	"./tenderloin.jpg": 8509,
	"./the-pig.svg": 7660,
	"./uddannelses-forløb.png": 2232,
	"./udskæring-gamle-dage.jpg": 8729,
	"./vaskeplads-gamle-dage.jpg": 7056
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 990;